import { createStore, useStore } from './createStore'

/* ---------------------------------------------------------------- language */

const langStore = createStore<Iziplay.Lang>('en-US')

export const getLang = () => langStore.get()
export const setLang = (lang: Iziplay.Lang) => langStore.set(lang)
export const useLang = () => useStore(langStore)

/* -------------------------------------------------------------- breadcrumb */

const currentPathStore = createStore<string[]>([])

export const setCurrentPath = (path: string[]) => currentPathStore.set(path)
export const useCurrentPath = () => useStore(currentPathStore)

/* ----------------------------------------------------------------- sidebar */

const mobileSidebarStore = createStore(false)

export const setMobileSidebar = (open: boolean) => mobileSidebarStore.set(open)
export const useMobileSidebar = () => useStore(mobileSidebarStore)

/* ------------------------------------------------------------ private mode */

const privateModeStore = createStore(false)

export const getPrivateMode = () => privateModeStore.get()
export const setPrivateMode = (on: boolean) => privateModeStore.set(on)
export const usePrivateMode = () => useStore(privateModeStore)

/* ----------------------------------------------------------- notifications */

export type NotificationType = 'success' | 'error' | 'info'

export interface Notification {
  message: string
  type: NotificationType
  color: string
  classes: string
}

const COLORS: Record<NotificationType, string> = {
  success: 'rgba(103, 212, 80, 0.9)',
  error: 'rgba(212, 81, 81, 0.9)',
  info: 'rgba(52, 152, 219, 0.9)'
}

const notificationStore = createStore<Notification>({
  message: '',
  type: 'success',
  color: '',
  classes: 'notificationBar opacity hide'
})

let notificationTimers: ReturnType<typeof setTimeout>[] = []

/*
 * Called from event handlers and axios callbacks all over the app, so it stays
 * a plain function rather than a hook. The class-name dance drives the CSS
 * transition in notification.css and is kept as it was.
 */
export function displayNotification(message: string, type: NotificationType, timeout = 3) {
  const resolved: NotificationType = COLORS[type] ? type : 'success'

  notificationTimers.forEach(clearTimeout)
  notificationTimers = []

  notificationStore.set({
    message,
    type: resolved,
    color: COLORS[resolved],
    classes: 'notificationBar opacity'
  })

  notificationTimers.push(
    setTimeout(() => {
      notificationStore.set(prev => ({ ...prev, classes: 'notificationBar' }))
    }, 10)
  )

  notificationTimers.push(
    setTimeout(() => {
      notificationStore.set(prev => ({ ...prev, classes: 'notificationBar opacity' }))
      notificationTimers.push(
        setTimeout(() => {
          notificationStore.set(prev => ({ ...prev, classes: 'notificationBar opacity hide' }))
        }, 100)
      )
    }, timeout * 1000)
  )
}

export const useNotification = () => useStore(notificationStore)
